import axios from "axios";
import { createStore, get as idbGet, set as idbSet, clear as idbClear } from "idb-keyval";

const apiCache = createStore("ir-api-cache", "responses");
const CACHEABLE = /^\/(interventions|auth\/me|settings|folders)/;
const cacheKey = (c) => `${c.url}?${JSON.stringify(c.params || {})}`;
const isCacheable = (c) => c && c.method === "get" && c.responseType !== "blob" && CACHEABLE.test(c.url || "");
export const clearApiCache = () => idbClear(apiCache).catch(() => {});

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const TOKEN_KEY = "bc_token";

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  if (isCacheable(config) && !config.timeout) config.timeout = 20000;
  return config;
});

// Offline: keep last GET responses on the device and serve them when the network is down
api.interceptors.response.use(
  (res) => {
    if (isCacheable(res.config)) idbSet(cacheKey(res.config), res.data, apiCache).catch(() => {});
    return res;
  },
  async (err) => {
    const c = err.config;
    if (!err.response && isCacheable(c)) {
      const data = await idbGet(cacheKey(c), apiCache).catch(() => undefined);
      if (data !== undefined) return { data, status: 200, headers: {}, config: c, fromCache: true };
    }
    return Promise.reject(err);
  },
);

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Une erreur est survenue. Réessayez.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function fileUrl(storagePath) {
  const token = localStorage.getItem(TOKEN_KEY);
  return `${API}/files/${storagePath}?auth=${token}`;
}
